import React, { useState } from 'react';
import {
  FaCube, FaBaby, FaSeedling, FaBalanceScale, FaClock, FaHandsHelping,
  FaChartLine, FaBriefcase, FaUserFriends, FaComments, FaFemale, FaUsers
} from 'react-icons/fa';

const initiatives = [
    {
     icon: <FaBalanceScale />,
     title: 'Equal Pay Initiatives',
     text: "Equal pay for equal work. That's just common sense!",
   },
   {
     icon: <FaClock />,
     title: 'Flexible Working Arrangements',
     text: 'Flexibility improves morale, increases productivity and company performance.',
   },
   {
     icon: <FaHandsHelping />,
     title: 'Mentorship Program',
     text: 'Women with mentors feel more supported and satisfied with their career.',
   },
   {
     icon: <FaChartLine />,
     title: 'Leadership Development Program',
     text: 'Advance your career with an employer that supports female leadership.',
   },
   {
     icon: <FaBaby />,
     title: 'Paid Parental Leave',
     text: 'Parents are happier and more engaged at work when they have paid parental leave.',
   },
   {
     icon: <FaBriefcase />,
     title: 'Return to Work Policy',
     text: "If you're ready to restart your career, you need support and training for the transition.",
   },
   {
     icon: <FaCube />,
     title: 'Childcare Facilities',
     text: "It takes a village to raise a child. What's better than facilities right at your workplace?",
   },
   {
     icon: <FaBaby />,
     title: 'Breastfeeding Rooms',
     text: 'Providing mothers the privacy and comfort they need when returning from maternity leave.',
   },
   {
     icon: <FaSeedling />,
     title: 'Sponsorship Program',
     text: 'Sponsorship program is critically important to keep the talent pipeline full and enable women to successfully climb the corporate ladder.',
   },
   {
     icon: <FaComments />,
     title: 'Coaching Program',
     text: 'Continuous learning is critical to keep up with the evolving changes in every jobs.',
   },
   {
     icon: <FaFemale />,
     title: 'Raise Numbers Of Women In Leadership',
     text: 'We need more women representation in leadership because it leads to more inclusive policies and initiatives.',
   },
   {
     icon: <FaUsers />,
     title: "Internal Women's Networking Group",
     text: 'Having a network of women to reach out to, discuss and champion women initiatives at work.',
   },
];

const CompanyInitiatives = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const itemsPerSlide = 3;
    const totalSlides = Math.ceil(initiatives.length / itemsPerSlide);

    const handleSlideChange = (index) => {
        setCurrentSlide(index);
    };

    const paginatedInitiatives = initiatives.slice(
        currentSlide * itemsPerSlide,
        (currentSlide + 1) * itemsPerSlide
    );

    return (
        <section className="bg-white py-20">
            <div className="container mx-auto px-4">
                <header className="text-center mb-16">
                    <h2 className="text-4xl font-bold text-gray-800 tracking-tight">
                        See how Companies that Care™ Empower Women
                    </h2>
                </header>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-12">
                    {paginatedInitiatives.map((initiative, index) => (
                        <div key={index} className="text-center">
                            <figure className="flex justify-center items-center mb-5 text-cyan-500">
                                {React.cloneElement(initiative.icon, { className: 'w-12 h-12' })}
                            </figure>
                            <header>
                                <h4 className="font-bold text-xl text-gray-900 mb-3">{initiative.title}</h4>
                            </header>
                            <article>
                                <p className="text-gray-600 leading-relaxed">{initiative.text}</p>
                            </article>
                        </div>
                    ))}
                </div>
                <div className="flex justify-center mt-16 space-x-3">
                    {Array.from({ length: totalSlides }).map((_, index) => (
                        <button
                            key={index}
                            onClick={() => handleSlideChange(index)}
                            className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                                currentSlide === index ? 'bg-pink-500' : 'bg-gray-300 hover:bg-gray-400'
                            }`}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CompanyInitiatives; 